import api from './api.service';

export default {
    createVendorNote(data) {
        return api.post('/vendor/vendor-notes', data);
    },
    updateVendorNote(noteId, data) {
        return api.put(`/vendor/vendor-notes/${noteId}`, data);
    },
    getVendorNotes(vendorId, companyId) {
        return api.get(`/vendor/vendor-notes?vendorId=${vendorId}&companyId=${companyId}`);
    },
    getCompanyVendorNotes(companyId) {
        return api.get(`/vendor/vendor-notes?companyId=${companyId}`);
    },
    uploadVendorNoteAttachments(noteId, companyId, formData) {
        return api.post(`/vendor/vendor-notes/${noteId}/attachments?companyId=${companyId}`, formData);
    },
    viewVendorNoteAttachment(attachmentId, companyId) {
        return api.get(`/vendor/vendor-notes/attachments/${attachmentId}/view?companyId=${companyId}`, {
            responseType: 'blob'
        });
    },
    deleteVendorNoteAttachment(attachmentId, companyId) {
        return api.delete(`/vendor/vendor-notes/attachments/${attachmentId}?companyId=${companyId}`);
    }
};
